import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import { Connect, PropsFromRedux } from './TypeSelectorScrollableContainer';
import { doctrineAnalytics } from '../../../utils/analyticsUtils';
import { useRestrictedModal } from '../../../components/modal/useRestrictedModal';
import { useUser } from '../../../user/useUser';
import styles from './type_selector_scrollable.module.scss';

type Props = PropsFromRedux & { onSelection: Function };

const RawTypeSelectorScrollable: FC<Props> = ({
  types,
  onTypeChanged,
  query,
  onSelection,
}) => {
  const { accessPremium } = useUser();
  const { openRestrictedModal } = useRestrictedModal();

  const onTypeChange = (selectedType: Props['types'][0]) => () => {
    if (accessPremium) {
      onTypeChanged(selectedType.key, query);
      doctrineAnalytics('Search TypeOfResultChanged', {
        type: selectedType.key,
        source: 'header',
      });
    } else {
      openRestrictedModal({ source: 'search-types' });
    }
    onSelection();
  };

  return (
    <div className={styles.selectors}>
      <div className={styles.wrapper}>
        <div className={styles.gutter}>
          {types.map((type: Props['types'][0]) => (
            <button
              type="button"
              key={type.key}
              onClick={onTypeChange(type)}
              className={classNames(styles.chip, {
                [styles.selected]: type.selected,
              })}
            >
              <FormattedMessage id={type.labelId} />
            </button>
          ))}
        </div>
      </div>
      <span className={styles.overlay} />
    </div>
  );
};

export const TypeSelectorScrollable = Connect(RawTypeSelectorScrollable);
